import React from 'react';
import { useDispatch } from 'react-redux';
import { CloseOutlined } from '@ant-design/icons';
import { clearHelperState } from '@/actions/helperAction';

const LinkPreview = ({ website_info, closable = false }) => {
  const dispatch = useDispatch();
  return (
    <div className="link-preview-card cursor-pointer card border shadow-none p-2">
      <div className="">
        {
          <>
            <a
              href={`${website_info?.url}`}
              target="__blank"
              className="position-relative text-center row d-flex"
            >
              <div className="col-lg-4 border-right">
                <img
                  className="card-img-top"
                  src={website_info?.image ? website_info?.image : ''}
                  alt="Link Preview"
                />
              </div>
              {/* <hr style={{ color: '#dee2e6' }} /> */}
              <div className="card-body col-lg-8">
                {closable && (
                  <div className="close-button">
                    <CloseOutlined
                      rev=""
                      className="ml-auto"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        dispatch(clearHelperState());
                        e.preventDefault();
                      }}
                    />
                  </div>
                )}
                {!website_info?.error && (
                  <>
                    <div
                      className="card-text text-left"
                      style={{
                        fontSize: '14px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                      }}
                    >
                      <u>{website_info?.title}</u>
                    </div>
                    <div className="link-website text-left font-size-sm mt-1">
                      <small style={{ color: '#6a6c72' }}>
                        {website_info?.description}
                      </small>
                    </div>
                  </>
                )}
                <div className="link-website text-left mt-1">
                  {website_info?.url?.replace('https://', '')}
                </div>
              </div>
            </a>
          </>
        }
      </div>
    </div>
  );
};

export const NewLinkPreview = ({ website_info, closable = false }) => {
  const dispatch = useDispatch();

  return (
    <div className="link-preview-card cursor-pointer card border shadow-none p-2">
      <div className="">
        {
          <>
            <a
              href={`${website_info?.url}`}
              target="__blank"
              className="position-relative text-center"
            >
              <div className="">
                <img
                  // className="card-img-top"
                  src={website_info?.image ? website_info?.image : ''}
                  alt="Link Preview"
                />
              </div>
              {/* <hr style={{ color: '#dee2e6' }} /> */}
              <div className="card-body">
                {closable && (
                  <div className="close-button">
                    <CloseOutlined
                      rev=""
                      className="ml-auto"
                      style={{ cursor: 'pointer' }}
                      onClick={(e) => {
                        dispatch(clearHelperState());
                        e.preventDefault();
                      }}
                    />
                  </div>
                )}
                {!website_info?.error && (
                  <>
                    <div
                      className="card-text text-left"
                      style={{
                        fontSize: '12px',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                      }}
                    >
                      <b>{website_info?.title}</b>
                    </div>
                    <div className="link-website text-left font-size-sm mt-1">
                      <small style={{ color: '#6a6c72' }}>
                        {website_info?.description}
                      </small>
                    </div>
                  </>
                )}
                <div className="link-website text-left mt-1">
                  {website_info?.url?.replace('https://', '')}
                </div>
              </div>
            </a>
          </>
        }
      </div>
    </div>
  );
};

export default LinkPreview;
